import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ element }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <div>الرجاء الانتظار</div>;

  return isAuthenticated ? element : <Navigate to="/loginPage" replace />;
};

export default ProtectedRoute;